export const breadcrumbClicked = {
    event: "breadcrumb_clicked",
    eventCategory: "homepage",
    eventAction: "Breadcrumb_clicked",
    eventLabel: "sell-used-cars"
};
